<template>
  <ui-box class="ui-box-apply" bgType="light">
    <template v-slot:nav-left>
      <ui-tag class="title">
        <i></i>
        <div class="label-box">
          <span class="label-shadow">信息确认</span>
          <span class="label-text">信息确认</span>
        </div>
      </ui-tag>
    </template>
    <template v-slot:nav-right>
      <div class="right-box">
        <button class="btn-exit" @click="handleExit"></button>
      </div>
    </template>
    <template v-slot:container>
      <div class="inner-container">
        <div class="scroll-box">
          <div class="info-box">
            <div class="row" v-for="item in question" :key="item.id">
              <div class="q">{{ item.q }}</div>
              <div class="checkbox">
                <div class="yes" :class="{ active: item.state == '1' }">
                  <div class="label-box">
                    <span class="label-shadow">是</span>
                    <span class="label-text">是</span>
                  </div>
                  <input type="radio" :name="item.id" v-model="item.state" value="1">
                </div>
                <div class="no" :class="{ active: item.state == '2' }">
                  <div class="label-box">
                    <span class="label-shadow">否</span>
                    <span class="label-text">否</span>
                  </div>
                  <input type="radio" :name="item.id" v-model="item.state" value="2">
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="bottom-box">
          <div class="bg"></div>
          <div class="decorate"></div>
          <ui-frame-bg class="btn prev" colorType="blue" @click.native="prev">
            <div class="label-box">
              <span class="label-shadow">上一项</span>
              <span class="label-text">上一项</span>
            </div>
          </ui-frame-bg>
          <ui-frame-bg class="btn next" colorType="yellow" @click.native="next">
            <div class="label-box">
              <span class="label-shadow">下一项</span>
              <span class="label-text">下一项</span>
            </div>
          </ui-frame-bg>
        </div>
      </div>
    </template>
  </ui-box>
</template>

<script>
import UiBox from '@/components/ui-box';
import UiTag from '@/components/ui-tag';
import UiFrameBg from '@/components/ui-frame-bg';

export default {
  components: { UiBox, UiTag, UiFrameBg },
  inject: ['handleStepSubmit', 'handleStep', 'json_config', 'promptMsg'],
  computed: {
    question() {
      let config = this.json_config();
      if(config.registration_questions) {
        return config.registration_questions.map(item => {
          this.$set(item, 'state', '')
          return item;
        })
      }else {
        return [];
      }
    }
  },
  methods: {
    prev() {
      this.handleStep(2)
    },
    validInfo() {
      let valid = true;
      for(let item of this.question) {
        if(typeof item.state == 'string' && item.state == '') {
          valid = false;
          this.promptMsg('请进行信息确认')
          break;
        }
      }

      return valid;
    },
    next() {
      let valid = this.validInfo()
      if(valid) {
        this.handleStepSubmit(3, this.question);
        this.handleStep(4)
      }
    },
    handleExit() {
      this.$emit('confirm')
    }
  }
}
</script>

<style lang="scss" scoped>
.title {
  font-weight: 500;
  i {
    position: relative;
    @include sizeSet($width: 36px, $height: 36px);
    @include icon_status('info_2', $hook: 'all');
    margin-right: get_vh(8px);
  }
  .label-box {
    .label-shadow {
      color: #FFFFFF;
    }
    .label-text {
      color: #133469;
    }
  }
}

.right-box {
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  height: 100%;
  .btn-exit {
    @include sizeSet($width: 92px, $height: 44px);
    background-image: $bg_btn;
    background-size: get_vh(786px) get_vh(384px);
    background-position: get_vh(-13px) get_vh(-212px);
    background-repeat: no-repeat;
    @include marginSet($marginTop: 4px);
    @include boxShadowSet_Btn;
    @media screen and (max-aspect-ratio: 3/2) {
      background-size: get_vw(786px) get_vw(384px);
      background-position: get_vw(-13px) get_vw(-212px);
    }
  }
}

.inner-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  border-radius: 0px 0px get_vh(20px) get_vh(20px);
  overflow: hidden;
  .scroll-box {
    flex: 1;
    width: 98.5%;
    margin: 0 auto;
    overflow-y: scroll;
    overflow-x: hidden;
    padding-bottom: get_vh(50px);
    .info-box {
      width: get_vw(820px);
      margin: get_vh(27px) auto;
      font-size: get_vh(20px);
      color: #333;
      overflow: hidden;
      .row {
        width: 100%;
        height: get_vh(54px);
        display: flex;
        justify-content: space-between;
        align-content: center;
        margin-bottom: get_vh(19px);
        .q {
          flex: 1;
          display: flex;
          align-items: center;
        }
        .checkbox {
          width: get_vh(160px);
          height: 100%;
          display: flex;
          justify-content: flex-end;
          margin-left: get_vh(30px);
          .yes, .no {
            position: relative;
            width: get_vh(54px);
            height: get_vh(54px);
            display: flex;
            justify-content: center;
            align-items: center;
            background-image: $bg_btn;
            background-size: get_vh(786px) get_vh(384px);
            background-position: get_vh(-156px) get_vh(-168px);
            background-repeat: no-repeat;
            border-radius: get_vh(10px);
            overflow: hidden;
            @include boxShadowSet_Btn;
            margin-left: get_vh(15px);
            .label-box {
              .label-shadow {
                color: #FFFFFF;
              }
              .label-text {
                color: #616161;
              }
            }
            input {
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              margin: 0;
              opacity: 0;
            }

            &.active {
              background-position: get_vh(-156px) get_vh(-20px);
              .label-box {
                .label-shadow {
                  color: #133469;
                }
                .label-text {
                  color: #FFFFFF;
                }
              }
            }
          }
        }
      }
    }
  }
  .bottom-box {
    position: relative;
    width: 100%;
    height: get_vh(124px);
    display: flex;
    justify-content: space-between;
    align-items: center;
    .decorate {
      position: absolute;
      bottom: get_vh(-80px);
      right: get_vh(360px);;
      width: get_vh(164px);
      height: get_vh(167px);
      background-image: $bg_decorate;
      background-size: get_vh(1472px) get_vh(639px);
      background-position: get_vh(-574px) get_vh(-104px);
      background-repeat: no-repeat;
    }
    .bg {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: get_vh(180px);
      background-image: $bg_bottom;
      background-size: 100% 100%;
      background-position: center top;
      background-repeat: no-repeat;
    }
    .btn {
      position: relative;
      width: get_vh(266px);
      height: get_vh(70px);
      font-size: get_vh(28px);
      font-weight: bold;
      @include boxShadowSet_Btn;
      cursor: pointer;
      -webkit-tap-highlight-color: transparent;
      &:active {
        opacity: 0.9;
      }

      &.prev {
        margin-left: get_vh(42px);
      }
      &.next {
        margin-right: get_vh(42px);
      }
    }
  }
}
</style>